import styled from 'styled-components';

export const ShowcaseContainer = styled.div`
  position: relative;
  box-shadow: ${(props) => (props.fullWidth ? 'none' : '1px 1px 12px -6px')};
  border-radius: ${(props) => (props.fullWidth ? '0' : '8px')};
  @media (max-width: 768px) {
    width: ${(props) => (props.fullWidth ? '100%' : '90%')};
  }
  margin: auto;
  overflow: hidden;
  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 600ms linear;
    background-color: hsl(0deg, 0%, 0%, 18%);
  }
  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  &.lowOpacity {
    opacity: 0.4;
  }
`;

export const ProductShowcaseSection = styled.div`
  padding: 10px;
  border: 1px solid #bbb;
  border-radius: 6px;
  width: 95%;
  margin: auto;
  display: flex;
  column-gap: 12px;
  align-items: center;
  .imgWrapper {
    box-shadow: 0px 4px 8px -6px rgba(0, 0, 0, 0.7);
    position: relative;
    padding-top: 28%;
    flex-basis: 28%;
    flex-shrink: 0;
    border-radius: 6px;
    img {
      border-radius: 6px !important;
    }
  }

  @media (min-width: 768px) {
    width: 100%;
    gap: 20px;
    cursor: pointer;
  }
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  .topTitle {
    display: flex;
    align-items: center;
    gap: 10px;
    color: rgb(20 20 20 / 70%);
    font-weight: 500;
    font-size: clamp(14px, 2vw, 16px);
    img {
      width: 24px;
      @media (min-width: 768px) {
        width: 32px;
      }
    }
  }
  .priceSection {
    display: flex;
    align-items: center;
    column-gap: 10px;
    justify-content: space-between;
  }
  .pTitle {
    font-size: clamp(12px, 2vw, 18px);
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
    @media (min-width: 768px) {
      margin: 12px 0 2px;
    }
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .price {
    flex-shrink: 0;
    font-weight: 600;
    font-size: clamp(14px, 2vw, 17px);
  }
  .features {
    font-size: clamp(12px, 2vw, 15px);
    color: #838383;
    margin: 0 0 6px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    @media (min-width: 768px) {
      margin-bottom: 10px;
    }
  }
`;
export const RatingContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  padding: 4px;
  background-color: #eee;
  font-size: clamp(10px, 2vw, 14px);
  font-weight: 500;
  span {
    color: #414141;
    opacity: 0.8;
  }
  img {
    width: 14px;
    height: 14px;
  }
  @media (min-width: 768px) {
    gap: 10px;
  }
`;
export const RatingContainerNew = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  padding: 4px;
  background-color: #eee;
  font-size: clamp(10px, 2vw, 16px);
  font-weight: 500;
  span {
    color: #414141;
    opacity: 0.8;
  }
  img {
    width: 14px;
    height: 14px;
  }
  @media (min-width: 768px) {
    gap: 10px;
  }
`;
export const ViewStoreCta = styled.div`
  font-size: clamp(10px, 2vw, 12px);
  color: #ef4e5e;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 2px;
  img {
    width: 10px;
    height: 10px;
    margin-top: 2px;
  }
`;

export const ShowcaseNew = styled.div`
  margin: auto;
  border-radius: 8px;
  .pTitle {
    margin: 8px 0 10px;
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
    @media (min-width: 768px) {
      margin: 12px 0 4px;
    }
  }
  .detailsContainer {
    padding: 8px;
  }
  .price {
    flex-shrink: 0;
    font-weight: 600;
    font-size: clamp(14px, 2vw, 18px);
  }
  .flex {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 16px 0;
    @media (min-width: 768px) {
      margin: 6px 0 10px;
    }
  }
  .features {
    font-size: clamp(13px, 2vw, 15px);
    color: #838383;
    @media (min-width: 768px) {
      margin-bottom: 10px;
    }
  }
  .userBought {
    font-size: 11px;
    color: rgb(75, 157, 155);
    margin-left: -20px;
    font-weight: 500;
  }
  button {
    border: none;
    width: 100%;
    background: #ef4e5e;
    color: white;
    font-weight: 600;
    font-family: 'Montserrat';
    display: flex;
    align-items: center;
    padding: 16px 0;
    justify-content: center;
    gap: 4px;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    img {
      rotate: -90deg;
      width: 20px;
    }
    @media (min-width: 768px) {
      cursor: pointer;
      padding: 8px 0;
      font-size: 12px;
    }
  }
  @media (min-width: 768px) {
    display: flex;
    margin: 0;
    cursor: pointer;
    border-radius: 8px;
    align-items: center;
    padding: 10px;
    gap: 6px;
  }
  .imgWrapper {
    position: relative;
    background-image: url('https://images.myloapp.in/NestJsUploads/1701860785118-1668581912764-defaultimage-(1).webp');
    padding-top: 100%;
    border-radius: 8px;
    @media (min-width: 768px) {
      padding-top: 30%;
    }
    img {
      border-top-right-radius: 8px !important;
      border-top-left-radius: 8px !important;
      @media (min-width: 768px) {
        border-radius: 8px !important;
      }
    }
    flex-shrink: 0;
    flex-basis: 30%;
  }
`;

export const FlexImgSection = styled.div`
  display: flex;
  align-items: center;
`;
export const FlexImage = styled.img`
  border-radius: 50%;
  width: 22px;
  height: 22px;
  position: relative;
  z-index: ${(props) => (props.zIndex ? props.zIndex + 1 : 1)};
  transform: ${(props) =>
    props.zIndex
      ? `translate(-${props.zIndex * 10 - 3}px,0)`
      : 'translate(0,0)'};
`;
